module.exports = __webpack_public_path__ + "img/积分.c789904c.png";